import { AlertTriangle } from 'lucide-react'
import { Button } from '@design-system/components/button'
import { BillingLockedTooltip } from '@/components/billing/BillingLockedTooltip'
import { useTranslation } from 'react-i18next'

interface PlanViolationBannerProps {
  show: boolean
  isAdmin: boolean
  maxSeats: number
  memberCount: number
  /** Render the (locked) upgrade CTA; true when the org has an active subscription. */
  showUpgradeCta: boolean
}

export function PlanViolationBanner(props: PlanViolationBannerProps) {
  const { show, isAdmin, maxSeats, memberCount, showUpgradeCta } = props
  const { t } = useTranslation('app')

  if (!show) return null

  const seats = t('billing.seats', { count: maxSeats })
  const members = t('billing.members', { count: memberCount })

  return (
    <div
      role="alert"
      data-testid="billing-plan-violation-banner"
      className="flex items-start gap-3 rounded-xl border border-destructive/40 bg-destructive/10 p-4"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-destructive" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-destructive">
          {t('billing.violationTitle', { seats, members })}
        </p>
        <p className="mt-0.5 text-xs text-destructive/90">
          {t('billing.violationBody')}
        </p>
      </div>
      {isAdmin && showUpgradeCta && (
        <BillingLockedTooltip>
          <Button
            size="sm"
            variant="outline"
            disabled
            data-testid="billing-plan-violation-upgrade"
          >
            {t('billing.upgradePlan')}
          </Button>
        </BillingLockedTooltip>
      )}
    </div>
  )
}
